import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-brand-black my-auto h-full px-6 z-50" }
const _hoisted_2 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_3 = {
  key: 1,
  class: "flex w-full flex-col m-auto space-y-10 items-center"
}
const _hoisted_4 = { class: "flex w-full flex-col space-y-4 items-center" }
const _hoisted_5 = { class: "flex flex-col w-full items-center space-y-2" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col w-full items-center"
}
const _hoisted_7 = {
  key: 1,
  class: "m-auto text-brand-light-gray text-lg text-center"
}
const _hoisted_8 = { class: "text-brand-lime" }
const _hoisted_9 = { class: "flex flex-col space-y-3 w-full" }
const _hoisted_10 = { class: "flex w-full flex-col bg-brand-dark-gray rounded-lg h-14 relative" }
const _hoisted_11 = {
  key: 0,
  class: "text-red-400 text-sm text-center"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "flex m-auto space-x-2.5" }
const _hoisted_14 = { class: "my-auto pt-0.5" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.checkingStatus)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("svg", {
                    class: "animate-spin h-10 w-10 text-white",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("circle", {
                      class: "opacity-25",
                      cx: "12",
                      cy: "12",
                      r: "10",
                      stroke: "currentColor",
                      "stroke-width": "4"
                    }),
                    _createElementVNode("path", {
                      class: "opacity-75",
                      fill: "currentColor",
                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                  ], -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[8] || (_cache[8] = _createElementVNode("svg", {
                      width: "111",
                      height: "110",
                      viewBox: "0 0 111 110",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("rect", {
                        x: "2.5",
                        y: "2",
                        width: "106",
                        height: "106",
                        rx: "53",
                        fill: "#EBFF00"
                      }),
                      _createElementVNode("path", {
                        d: "M68.833 41.666H42.1663C40.333 41.666 38.8497 43.166 38.8497 44.9993L38.833 64.9993C38.833 66.8327 40.333 68.3327 42.1663 68.3327H68.833C70.6663 68.3327 72.1663 66.8327 72.1663 64.9993V44.9993C72.1663 43.166 70.6663 41.666 68.833 41.666ZM68.1663 48.7493L56.383 56.116C55.8497 56.4493 55.1497 56.4493 54.6163 56.116L42.833 48.7493C42.6659 48.6555 42.5195 48.5288 42.4028 48.3768C42.2861 48.2248 42.2014 48.0506 42.154 47.865C42.1065 47.6793 42.0972 47.4859 42.1266 47.2965C42.156 47.1071 42.2236 46.9257 42.3251 46.7632C42.4267 46.6007 42.5602 46.4604 42.7176 46.351C42.8749 46.2416 43.0528 46.1652 43.2405 46.1265C43.4282 46.0878 43.6218 46.0876 43.8096 46.1259C43.9974 46.1642 44.1754 46.2402 44.333 46.3493L55.4997 53.3327L66.6663 46.3493C66.8239 46.2402 67.002 46.1642 67.1898 46.1259C67.3775 46.0876 67.5711 46.0878 67.7589 46.1265C67.9466 46.1652 68.1245 46.2416 68.2818 46.351C68.4391 46.4604 68.5726 46.6007 68.6742 46.7632C68.7758 46.9257 68.8433 47.1071 68.8727 47.2965C68.9022 47.4859 68.8929 47.6793 68.8454 47.865C68.7979 48.0506 68.7132 48.2248 68.5965 48.3768C68.4798 48.5288 68.3335 48.6555 68.1663 48.7493Z",
                        fill: "#1A1B22"
                      }),
                      _createElementVNode("rect", {
                        x: "2.5",
                        y: "2",
                        width: "106",
                        height: "106",
                        rx: "53",
                        stroke: "#EBFF00",
                        "stroke-width": "4"
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_5, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex m-auto text-white text-2xl font-medium" }, "Check your inbox", -1)),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_ion_skeleton_text, {
                              class: "w-8/12 h-5",
                              animated: ""
                            }),
                            _createVNode(_component_ion_skeleton_text, {
                              class: "w-10/12 h-5",
                              animated: ""
                            }),
                            _createVNode(_component_ion_skeleton_text, {
                              class: "w-5/12 h-5",
                              animated: ""
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _cache[5] || (_cache[5] = _createTextVNode(" A confirmation email has been sent to ", -1)),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.user?.email), 1),
                            _cache[6] || (_cache[6] = _createTextVNode(". Enter the 6-character code we emailed you. ", -1))
                          ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_ion_input, {
                        modelValue: _ctx.code,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
                        class: "text-white text-lg font-medium absolute top-0 left-0 h-full px-4 text-center tracking-widest",
                        placeholder: "6-character code",
                        maxlength: "6",
                        autocapitalize: "characters"
                      }, null, 8, ["modelValue"])
                    ]),
                    (_ctx.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.error), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.verify && _ctx.verify(...args))),
                      disabled: _ctx.busy || _ctx.loading || _ctx.code.trim().length !== 6,
                      class: "flex bg-brand-lime rounded-full w-full h-14 font-medium text-xl text-brand-black disabled:opacity-40"
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          (!_ctx.busy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Verify"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[9] || (_cache[9] = [
                                _createElementVNode("svg", {
                                  class: "animate-spin h-5 w-5 text-brand-black",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  fill: "none",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("circle", {
                                    class: "opacity-25",
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    "stroke-width": "4"
                                  }),
                                  _createElementVNode("path", {
                                    class: "opacity-75",
                                    fill: "currentColor",
                                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  })
                                ], -1)
                              ]))]))
                        ])
                      ])
                    ], 8, _hoisted_12),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resend && _ctx.resend(...args))),
                      disabled: _ctx.busy || _ctx.loading,
                      class: "flex bg-brand-dark-gray rounded-full w-full h-14 font-medium text-xl text-white disabled:opacity-40"
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
                        _createElementVNode("div", { class: "my-auto pt-0.5" }, " I didn’t get it ")
                      ], -1)
                    ]))], 8, _hoisted_17),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                      class: "flex rounded-full w-full h-14 font-medium text-xl text-white"
                    }, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
                        _createElementVNode("div", { class: "my-auto pt-0.5" }, " Logout ")
                      ], -1)
                    ]))])
                  ])
                ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}